
import React, { useContext, useState, useRef, useEffect } from "react";
import Breadcrumb from '../Settings_components/Breadcrumb';

import { AppContext } from '../../../context/context.js';
import Pagination from '../../../utils/pagination';

import axios from "axios";
import PaymentTableItems from "../Settings_components/PaymentTableItems.js";
import { useNavigate } from "react-router-dom";
import WarrantyTableItems from "../Settings_components/WarrantyTableItems.js";
import { useLocation } from 'react-router-dom';
import Swal from "sweetalert2";

const WarrantySettings = () => {
  const {
      state,
      isLoading,
      updateWarrantyList,
  } = useContext(AppContext);

  const { warrantyList } = state;
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const [currentPage, setCurrentPage] = useState(1);
  const perPage = 20;

  //---------------------
  const location = useLocation();
  const [hasPermission, setHasPermission] = useState(false);
  useEffect(() => {
    const employeeApiResponse = localStorage.getItem("employee");

    if (!employeeApiResponse) {
      setHasPermission(true);
      return; // Exit useEffect early
    }

    if (employeeApiResponse) {
      // Parse the employee data from local storage
      const employeeData = JSON.parse(employeeApiResponse);

      // Get the "Exporter" feature from the employee's role features
      const settingsFeature = employeeData.role.features.find(
        (feature) => feature.name === "Settings"
      );

      // Check if the "Exporter" feature and "Visible" option are both active
      if (settingsFeature && settingsFeature.status === 1) {

        // Grant access based on the route and permissions
        if (location.pathname === "/settings/warranty") {
          setHasPermission(true);
          return; // Exit useEffect if permission is granted
        }
      }
      setHasPermission(false);
      // If no permission, navigate to dashboard first
      navigate("/dashboard", { replace: true });
      setTimeout(() => {
        Swal.fire({
          icon: "error",
          title: "Permission Denied",
          text: "You do not have permission for this feature.",
        });
      }, 100);
    }
    // If not an employee, the useEffect gets skipped
  }, [navigate, location]);
  //---------------------

  useEffect(() => {
    if(hasPermission){
      getWarranty(currentPage);
    }
  }, [currentPage,hasPermission]);

  const onPageChange = (page) => {
      setCurrentPage(page);
  }

  const [loading, setLoading] = useState(false);
  const loadingCallback = loading => {
      setLoading(loading);
  };

  const getWarranty = (page) => {
    loadingCallback(true)
    axios.get(
      `${process.env.REACT_APP_API_URL}get-warranty-list?page=${page}&limit=${perPage}`,
      {
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      if(response.data.success)
      {
        loadingCallback(false)
        console.log(response.data.data);
        updateWarrantyList(response.data.data)
        console.log("============");
        console.log(response.data.data);
      }
    })
    .catch((error) => {
      navigate('/login');
      console.log(error);
    });
  };

  const shouldRenderPagination = state.warrantyList?.total > perPage;

  console.log(warrantyList);

  return (
    <div className='rounded-[27px]'  style={{backgroundColor: 'rgba(0, 184, 148, 0.15)' }}>
      <Breadcrumb></Breadcrumb>

      <WarrantyTableItems loading={loading} data={warrantyList} accountData={warrantyList} getWarranty={getWarranty}></WarrantyTableItems>
        {shouldRenderPagination && (
          <Pagination
            currentPage={currentPage}
            lastPage={state.warrantyList.last_page}
            onPageChange={onPageChange}
          />
        )}
        <div className="w-full relative px-10 md:px-[27px] overflow-x-auto sm:rounded-lg">
          {loading && (
            <div className="custom-loader"></div>
          )}
        </div>
    </div>
  );
};

export default WarrantySettings;